import request from './axiosFun';
import apiHttp from './apiHttp';
// 人员列表
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 上传图片
export function uploadFile(data) {
  return request({
    url: url + '/pasture/sys/uploadFile',
    method: 'post',
    data,
    notoken: 'old'
  });
}
// 新权限初始化数据
export function getMenuTreeByApplicationId(query) {
  return apiHttp({
    url: url + '/pasture-manage/sysManage/getMenuTreeByApplicationId',
    method: 'post',
    data: query
  });
}
// 新组织机构列表
export function organizationList(query) {
  return request({
    url: url + '/pasture/sys/selectAllDept',
    method: 'post',
    data: query
  });
}
// 新下发机构列表
export function Issuingagency(query) {
  return request({
    url: url + '/pasture/sys/getNextDeptListByPId',
    method: 'post',
    data: query
  });
}
// 新增编辑机构校验手机号
export function verifymobilenumber(query) {
  return request({
    url: url + '/pasture/userInfo/checkAuthUser',
    method: 'post',
    data: query
  });
}
// 新新增防疫员选择村子列表
export function fyucunziList(query) {
  return request({
    url: url + '/pasture/sys/selectByPCityAreasByIds',
    method: 'post',
    data: query
  });
}
// 新导入表格模板
export function Formtemplate(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/downExcelTemp',
    method: 'get',
    data: query
  });
}
// // 新新增防疫员选择村子列表
// export function fyucunziList (query) {
//   return request({
//     url: url + '/pasture/sys/selectBellowLevelById',
//     method: 'post',
//     data: query

//   })
// }
// 新人员列表
export function getUserList(query) {
  return request({
    url: url + '/pasture/sys/getAllBellowUserListByAreasIdWithPageInfo',
    method: 'post',
    data: query
  });
}
// export function getUserList (query) {
//   return request({
//     url: url + '/pasture/userInfo/getAllBellowUserListByAreasIdWithPageInfo',
//     method: 'post',
//     data: query

//   })
// }
// 字典类型
export function findDictList(query) {
  return request({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: query
  });
}
// 动态字典
export function getDataByDynamicCode(query) {
  return request({
    url: url + '/pasture/dynamicData/getDataByDynamicCode',
    method: 'post',
    data: query
  });
}

// 删除(新)
export function delAuthUser(query) {
  return request({
    url: url + '/pasture/userInfo/delAuthUser',
    method: 'post',
    data: query
  });
}
// 删除(新)(李老师3.7)
export function delImmunizeUser(query) {
  return request({
    url: url + '/pasture/userInfo/delImmunizeUser',
    method: 'post',
    data: query
  });
}
// 新增（新）
export function addOrUpdate(query) {
  return request({
    url: url + '/pasture/userInfo/addMaterImmunizeUser',
    method: 'post',
    data: query
  });
}
// 查询下级区域

export function selectByPCityAreas(query) {
  return request({
    url: url + '/pasture/sys/selectByPCityAreas',
    method: 'post',
    data: query,
    platFlag: 'notoken'
  });
}
//新当前账号等级下所有辖区
export function selectAreasByDeptId(query) {
  return request({
    url: url + '/pasture/sys/selectByPCityAreas',
    method: 'post',
    data: query
  });
}
// 查询当全前菜单信息
export function getUserAuthInfo(query) {
  return request({
    url: url + '/base-server/loginCore/getUserWebPermission',
    method: 'post',
    data: query
  });
}
// 查询当前项目菜单
export function getWebMenuTreeByAppId(query) {
  return request({
    url: url + '/base-server/loginCore/getWebMenuTreeByAppId',
    method: 'post',
    data: query
  });
}
// 查询智慧养殖项目菜单
export function getWebMenuTreeByFarmId(query) {
  return request({
    url: url + '/base-server/loginCore/getWebMenuTreeByFarmId',
    method: 'post',
    data: query
  });
}
// 菜单权限添加
export function allocationFarmRoleMenu(query) {
  return request({
    url: url + '/pasture/zhyzUser/allocationFarmRoleMenu',
    method: 'post',
    data: query
  });
}
// 获取养殖场信息
export function getUserFarmInfo(query) {
  return request({
    url: url + '/base-server/loginCore/getUserFarmInfo',
    method: 'post',
    data: query
  });
}
// 查询省

export function chaxunsheng(query) {
  return request({
    url: url + 'pasture/sys/selectByAreas',
    method: 'post',
    data: query
  });
}

// (新)编辑
export function editOrUpdate(query) {
  return request({
    url: url + '/pasture/userInfo/updateAuthUser',
    method: 'post',
    data: query
  });
}
// (新)信息员变更
export function changeAuthUser(query) {
  return request({
    url: url + '/pasture/userInfo/changeAuthUser',
    method: 'post',
    data: query
  });
}
// 查询组织机构列表

export function selectAllDept(query) {
  return request({
    url: url + '/pasture/lsorganization/selectAllDept',
    method: 'post',
    data: query
  });
}
// （新）新增组织机构

export function addDept(query) {
  return request({
    url: url + '/pasture/sys/addDept',
    method: 'post',
    data: query
  });
}
// 更新组织机构
export function updateDept(query) {
  return request({
    url: url + '/pasture/sys/updateDept',
    method: 'post',
    data: query
  });
}
// 删除组织机构

export function delDept(query) {
  return request({
    url: url + '/pasture/sys/delDept/' + query.id,
    method: 'get'
  });
}

// 新增防疫

export function addOrUpdateAuthUser(query) {
  return request({
    url: url + '/pasture/userInfo/addOrUpdateAuthUser',
    method: 'post',
    data: query
  });
}
// 防疫列表
export function getUserListByDeptId(query) {
  return request({
    url: url + '/pasture/userInfo/getUserListByDeptId',
    method: 'post',
    data: query
  });
}
// 删除防疫人员

export function delAuthUserFY(query) {
  return request({
    url: url + '/pasture/userInfo/delAuthUser',
    method: 'post',
    data: query
  });
}
// 更新防疫人员信息
export function updateAuthUserFY(query) {
  return request({
    url: url + '/pasture/userInfo/updateAuthUser',
    method: 'post',
    data: query
  });
}
// 人员各类型数量

export function getAllBellow(query) {
  return request({
    url: url + '/pasture/userInfo/getAllBellowUserListByAreasIdWithPageInfoForStatistics',
    method: 'post',
    data: query
  });
}
// 下载excel模板

export function downExcelTemp(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/downExcelTemp',
    method: 'get',
    data: query
  });
}
// 导入防疫员模板
export function importExcel(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/importExcelForAuth',
    method: 'post',
    data: query
  });
}

// 人员管理的辖区

export function getDeptList(query) {
  return request({
    url: url + '/pasture/lsorganization/getDeptListByAreaId',
    method: 'post',
    data: query
  });
}
// 修改基本信息

export function updateFarmInfo(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/updateFarmInfo',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/system.js